import { T } from '@territory/tokens';

/* Scoped selector for a component root: 'button' -> '[data-rv-button]'. */
export const rvAttr = (name: string): string => `[data-rv-${name}]`;

/*
 * The one focus ring (CONVENTIONS.md): 2px accent outline, 2px offset, keyboard focus only. Pass the component's
 * data-rv name, or a full selector when the focusable element is a descendant of the root.
 */
export function focusRing(nameOrSelector: string): string {
  const sel = nameOrSelector.startsWith('[') ? nameOrSelector : rvAttr(nameOrSelector);
  return `${sel}:focus-visible { outline: 2px solid ${T.accent}; outline-offset: 2px; }\n${sel}:focus:not(:focus-visible) { outline: none; }`;
}
